import { render } from "./PartEdition.vue?vue&type=template&id=36d50868&scoped=true"
import script from "./PartEdition.vue?vue&type=script&lang=js"
export * from "./PartEdition.vue?vue&type=script&lang=js"

import "./PartEdition.vue?vue&type=style&index=0&id=36d50868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d50868"]])

export default __exports__